module.exports = __webpack_public_path__ + "img/mockup-tela-desktop.6cf64e85.png";